export default {
	editor: {
		placeholderText: 'Please enter your text here...',
	},
}
